// Função gerarPDF() para uso em ReactJS com pdfmake
// Inclui: capa com logotipo, sumário, página por ocorrência, NRs agrupadas, rodapé com página e logo

import pdfMake from 'pdfmake/build/pdfmake.min';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import logo from '../../assets/logoEhs.png'
import { LineWeight } from '@mui/icons-material';

export const gerarPDF = async (vistoria) => {

  const getLogoBase64 = async () => {
  const res = await fetch(logo);
  const blob = await res.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

const logoBase64 = await getLogoBase64(logo)


  const docDefinition = {
    pageMargins: [40, 60, 40, 40],
    footer: (currentPage, pageCount) => {
      return {
        columns: [
          { image: logoBase64, width: 50, alignment: 'left', margin: [40, 0, 0, 0] },
          { text: `Página ${currentPage} de ${pageCount}`, alignment: 'right', margin: [0, 0, 40, 0], fontSize: 9 }
        ]
      };
    },
    content: [
      { image: logoBase64, width: 100, alignment: 'center', margin: [0, 0, 0, 10] },
      { text: "RELATÓRIO DE INSPEÇÃO", style: 'title', alignment: 'center' },
      { text: `Empreendimento: ${vistoria.empreend}`, style: 'normal', margin: [0, 10] },
      { text: `Empresa: ${vistoria.nomeFantasia} (${vistoria.company})`, style: 'normal' },
      { text: `Endereço: ${vistoria.addressStreet}, ${vistoria.addressNum}, ${vistoria.addressBairro} - ${vistoria.addressCidade}/${vistoria.addressUF}`, style: 'normal' },
      { text: `Data: ${new Date(vistoria.dataHora).toLocaleString('pt-BR')}`, style: 'normal' },
      { text: `Vistoriador: ${vistoria.nomeVistoriador}`, style: 'normal', margin: [0, 0, 0, 20] },

      { text: "Sumário", style: "subheader" },
      {
        ul: [
          "1. Ocorrências",
          "2. Normas Regulamentadoras (NRs)"
        ],
        margin: [0, 0, 0, 20]
      }
    ],
    styles: {
      title: { fontSize: 18, bold: true },
      subheader: { fontSize: 14, bold: true, margin: [0, 10, 0, 5] },
      normal: { fontSize: 9, margin: [5, 0, 5, 0], lineHeight: 1.5 }
    }
  };

  // Ocorrências
  if (vistoria.ocorrencias?.length) {
    docDefinition.content.push({ text: "1. Ocorrências", style: "subheader", pageBreak: 'before' });

    for (const ocorrencia of vistoria.ocorrencias) {
      const imagens = [];
      for (const foto of ocorrencia.fotos || []) {
        try {
          const imageData = await getBase64ImageFromURL(foto.url);
          imagens.push({ image: imageData, width: 200, margin: [0, 5, 0, 5] });
        } catch (err) {
          console.warn("Erro ao carregar imagem:", foto.url);
        }
      }

      docDefinition.content.push(
        { text: ocorrencia.nome, style: "normal", bold: true, margin: [0, 10, 0, 0] },
        { text: ocorrencia.descricao, style: "normal" },
        { text: `Status: ${ocorrencia.status}`, style: "normal" },
        { text: `Localização: ${ocorrencia.localizacao?.latitude}, ${ocorrencia.localizacao?.longitude}`, style: "normal" },
        { text: "Imagens:", style: "normal", margin: [0, 10, 0, 5] },
        ...imagens,
        { text: "Interações:", style: "normal", margin: [0, 10, 0, 5] },
        ...ocorrencia.interacao.map(int => ({
          text: `- ${int.remetente} (${int.role}): ${int.mensagem}`, style: "normal"
        })),
        { text: "", margin: [0, 10] }
      );
    }
  }

  // NRs
  if (vistoria.nrs?.length) {
    docDefinition.content.push({ text: "2. Normas Regulamentadoras (NRs)", style: "subheader", pageBreak: 'before' });


    for (const nr of vistoria.nrs) {
 
      for (const doc of nr.items) {

       const statusText = () => {
          if (doc.status === 'C') return { text: [{ text: 'Status: ', bold: true }, 'Em Conformidade'], fontSize: 9, lineHeight: 1.5 };
          if (doc.status === 'novo') return  { text: [{ text: 'Status: ', bold: true }, 'Não Aferido'], fontSize: 9, lineHeight: 1.5 };
          if (doc.status === 'NA') return  { text: [{ text: 'Status: ', bold: true }, 'Não Se Aplica'], fontSize: 9, lineHeight: 1.5 };

          // Se status for 'N'
          if (doc.status === 'N' && doc.naoconforme) {
            return {
              stack: [
                  { text: [{ text: 'Ação: ', bold: true, fontSize: 9, lineHeight: 1.5 }, doc.naoconforme.acao] },
                  { text: [{ text: 'Responsável: ', bold: true, fontSize: 9, lineHeight: 1.5 }, doc.naoconforme.responsaveel] },
                  { text: [{ text: 'Conclusão: ', bold: true, fontSize: 9, lineHeight: 1.5 }, doc.naoconforme.conclusao] }
              ],
              margin: [0, 4]
            };
          }

          return 'Desconhecido';
            };
      
      docDefinition.content.push({
        stack: [
          { text: `📄 ${doc.documento}`, fontSize: 9, lineHeight: 1.5 },
          statusText()
        ],
        margin: [0, 0, 0, 8]
      });

      }
      docDefinition.content.push({ text: "", margin: [0, 5] });
    }
  }

  pdfMake.createPdf(docDefinition).download(`Relatorio_${vistoria.id}.pdf`);
};

const getBase64ImageFromURL = async (url) => {
  const res = await fetch(url);
  const blob = await res.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};